import { cfRegex } from "./../../../../utils/cfRegex";
import * as Yup from "yup";
import { getTodayDate, toEnDateString } from "../../../../utils/dateUtils";
import { isCustomerDistrictRequired } from "../../../../utils/districtUtils";

const todayDate = toEnDateString(getTodayDate());

export const phone = Yup.object().shape(
	{
		phone: Yup.number()
			.typeError("Inserire un numero valido")
			.when("mobile", {
				is: (mobile) => !mobile || mobile.length === 0,
				then: Yup.number().typeError("Inserire un numero valido").required("At least one of the fields is required"),
			}).nullable(),
		mobile: Yup.number()
			.typeError("Inserire un numero valido")
			.when("phone", {
				is: (mobile) => !mobile || mobile.length === 0,
				then: Yup.number().typeError("Inserire un numero valido").required("At least one of the fields is required"),
			}).nullable(),
	},
	["phone", "mobile"]
);

export const getValidationsPatient = (customer) => Yup.object().shape(
	{
		name: Yup.string().required("Obbligatorio").nullable(),
		surname: Yup.string().required("Obbligatorio").nullable(),
		cf: Yup.string()
			.matches(cfRegex, "Inserire CF valido")
			.required("Obbligatorio").nullable(),
		birthDate: Yup.date()
			.max(todayDate, `La data non può essere maggiore di oggi`)
			.required("Obbligatorio").nullable(),
		email: Yup.string().email("Inserire mail valida").nullable(),

		phone: Yup.number()
			.typeError("Inserire un numero valido")
			.when("mobile", {
				is: (mobile) => !mobile,
				then: Yup.number().typeError("Inserire un numero valido").required("Compilare almeno uno tra telefono o cellulare"),
			}).nullable(),
		mobile: Yup.number()
			.typeError("Inserire un numero valido")
			.when("phone", {
				is: (phone) => !phone,
				then: Yup.number().typeError("Inserire un numero valido").required("Compilare almeno uno tra telefono o cellulare"),
			}).nullable(),

		residence: Yup.object().shape({
			street: Yup.mixed().required("Obbligatorio").nullable(),
			number: Yup.mixed().required("Obbligatorio").nullable(),
			internal: Yup.number().typeError("Inserire un numero valido").nullable(),
			cap: Yup.number().required("Obbligatorio").typeError("Inserire un numero valido").nullable(),
			city: Yup.mixed().required("Obbligatorio").nullable(),
			province: Yup.mixed().required("Obbligatorio").nullable(),
			districtGuid: isCustomerDistrictRequired(customer)
				? Yup.string().required("Obbligatorio").nullable()
				: Yup.mixed().nullable(),
		}),

		domicile: Yup.mixed().when("isDomicileDifferent", {
			is: true,
			then: Yup.object().shape({
				street: Yup.mixed().required("Obbligatorio").nullable(),
				number: Yup.mixed().required("Obbligatorio").nullable(),
				internal: Yup.number().typeError("Inserire un numero valido").nullable(),
				cap: Yup.number().required("Obbligatorio").typeError("Inserire un numero valido").nullable(),
				city: Yup.mixed().required("Obbligatorio").nullable(),
				province: Yup.mixed().required("Obbligatorio").nullable(),
			}),
			otherwise: Yup.object().nullable().notRequired(),
		}),
	},
	["phone", "mobile"]
);
